export const isValidBic = (businessId) => {
  if (typeof businessId !== 'string') {
    return false;
  }

  const normalizedBusinessId = businessId.trim();

  // Format: 7 digits, hyphen, 1 check digit
  if (!/^\d{7}-\d$/.test(normalizedBusinessId)) {
    return false;
  }

  const digits = normalizedBusinessId.replace('-', '');
  const weights = [7, 9, 10, 5, 8, 4, 2];
  let sum = 0;

  for (let i = 0; i < weights.length; i += 1) {
    sum += Number(digits[i]) * weights[i];
  }

  const remainder = sum % 11;
  let checkDigit = 0;

  if (remainder === 0) {
    checkDigit = 0;
  } else if (remainder === 1) {
    return false;
  } else {
    checkDigit = 11 - remainder;
  }

  return checkDigit === Number(digits[7]);
};
